import React from 'react';

export default function InstitutionLogo({ institution }) {
	if(!institution || !institution.image_url) {
		return null;
	}

	return (
		<img className='institution_logo' src={institution.image_url} />
	);
}